import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  HiOutlineMail,
  HiOutlineArrowRight,
  HiOutlineShieldCheck,
  HiOutlineLightningBolt,
  HiOutlineKey,
} from "react-icons/hi";
import Labels from "../../services/apiLabels";
import { POST } from "../../constant/apiMethods";
import { FORGET_PASSWORD, TOASTER_SHOW, toaster_w } from "../../constant";
import FeedbackContext from "../../context/cmscontext";
import { scrollTop } from "../../utils/window";
import "../Login Page/client-login.css";
import "./style.css";

const publicUrl = process.env.PUBLIC_URL || "";
const VISUAL_IMAGE = `${publicUrl}/images/hero-evaluation.jpg`;

function Forget(props) {
  const { passworedReset, toasterShow } = props;
  const { feedback } = useContext(FeedbackContext);
  const forget_password_page = feedback?.forget_password_page || {};
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    scrollTop();
  }, []);

  const reSetPassword = (event) => {
    event.preventDefault();
    if (submitting) return;
    const nextEmail = email.trim();
    if (!nextEmail) {
      toasterShow({
        show: true,
        autoHide: false,
        type: toaster_w,
        description: "Please enter your email address.",
      });
      return;
    }
    setSubmitting(true);
    passworedReset({ email: nextEmail }, () => setSubmitting(false));
  };

  return (
    <div className="pi-login pi-forget">
      <div className="pi-login__fx" aria-hidden="true">
        <span className="pi-login__glow pi-login__glow--a" />
        <span className="pi-login__glow pi-login__glow--b" />
        <span className="pi-login__grid" />
      </div>

      <div className="pi-login__inner">
        <div className="pi-login__shell">
          <section className="pi-login__panel pi-login__panel--form">
            <header className="pi-login__head">
              <p className="pi-label">
                {forget_password_page.eyebrow || "Account recovery"}
              </p>
              <h1>
                {forget_password_page.forget_pass_text || "Forgot password"}
              </h1>
              <p className="pi-login__lead">
                {forget_password_page.lead ||
                  "Enter the email on your account and we’ll send reset instructions."}
              </p>
            </header>

            <form
              className="pi-login__form"
              onSubmit={reSetPassword}
              autoComplete="on"
            >
              <label className="pi-login__field" htmlFor="forget-email">
                <span className="pi-login__field-label">Email address</span>
                <span className="pi-login__control">
                  <HiOutlineMail size={18} aria-hidden />
                  <input
                    id="forget-email"
                    type="email"
                    name="email"
                    autoComplete="email"
                    required
                    placeholder={
                      forget_password_page.email_placeholder ||
                      "Enter email address"
                    }
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </span>
              </label>

              <button
                type="submit"
                className="pi-login__submit"
                name="CTAButton"
                disabled={submitting}
              >
                {submitting
                  ? "Sending…"
                  : forget_password_page.btn_forget_pass || "Send reset link"}
                {!submitting ? (
                  <HiOutlineArrowRight size={18} aria-hidden />
                ) : null}
              </button>
            </form>

            <p className="pi-login__footer-note">
              Remembered your password? <Link to="/login">Log in</Link>
            </p>
            <p className="pi-login__footer-note pi-forget__signup-note">
              Don&apos;t have an account? <Link to="/signup">Sign up</Link>
            </p>
          </section>

          <aside
            className="pi-login__panel pi-login__panel--visual"
            style={{ backgroundImage: `url(${VISUAL_IMAGE})` }}
            aria-hidden="true"
          >
            <span className="pi-login__visual-shade" />
            <div className="pi-login__visual-copy">
              <p className="pi-login__visual-kicker">AutoTrade Port</p>
              <h2>
                Reset access.
                <span> Get back on track.</span>
              </h2>
              <ul className="pi-login__visual-points">
                <li>
                  <HiOutlineKey size={16} />
                  Secure email reset link
                </li>
                <li>
                  <HiOutlineLightningBolt size={16} />
                  Back to your account quickly
                </li>
                <li>
                  <HiOutlineShieldCheck size={16} />
                  Protected account recovery
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  passworedReset: (data, callBack) =>
    dispatch({
      type: FORGET_PASSWORD,
      payload: {
        type: FORGET_PASSWORD,
        label: Labels.password_Reset,
        method: POST,
        data,
        hideOverlayLoader: true,
        callBack,
      },
    }),
  toasterShow: (data) =>
    dispatch({
      type: TOASTER_SHOW,
      payload: {
        ...data,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Forget);
